import { Info } from "lucide-react";
import { Link } from "react-router";

interface OutreachDisclaimerProps {
  /** When given, "log the contact" links to the campaign's Outreach workspace,
   *  where each candidate's contact log lives. Omit it on the workspace itself. */
  campaignId?: string;
  className?: string;
}

export const OUTREACH_DISCLAIMER =
  "Rarion does not send messages. Copy the draft into LinkedIn or your email client, then log the contact here.";

/**
 * The one line every outreach surface carries (#3169): drafts are drafts,
 * the contact log is a log, and nothing leaves Rarion on its own.
 */
export function OutreachDisclaimer({ campaignId, className = "" }: OutreachDisclaimerProps) {
  const logHref = campaignId ? `/campaigns/${campaignId}/run/outreach` : null;
  return (
    <p
      data-testid="outreach-disclaimer"
      className={`flex items-start gap-1.5 text-xs text-text-muted ${className}`}
    >
      <Info size={12} className="mt-0.5 shrink-0 text-text-faint" aria-hidden="true" />
      <span>
        Rarion does not send messages. Copy the draft into LinkedIn or your email client, then{" "}
        {logHref ? (
          <Link to={logHref} className="underline hover:text-text-secondary">
            log the contact here
          </Link>
        ) : (
          "log the contact here"
        )}
        .
      </span>
    </p>
  );
}
